<div class="venue-container" fxLayout="column" fxLayoutGap="14px">
  <div class="venue-hero venue-desktop-only">
    <div class="venue-hero-banner" [style.--hero-bg-url]="getHeroBannerBg()">
      <img [src]="(venueWideImage && !venueWideImage.includes('noimage')) ? venueWideImage : venueLogoImage" (error)="onImageError($event)" loading="lazy" [alt]="venueName || 'Venue Banner'">
    </div>
  </div>

  <section class="venue-info-container">
    <!-- Mobil yerleşim SCSS'teki @media (max-width: 959.98px) ile kurulur;
         eskiden [class.is-mobile-layout]="getIsMobile()" vardı. -->
    <div class="venue-content-layout">
      <aside class="venue-content-left">
        <div class="event-media-container mobile-event-media venue-mobile-only"
          style="padding: 0; margin-bottom: 20px;">
          <div class="mobileapp-header-container">{{ eventsDetailListByVenue?.venueName }}</div>
          <img [src]="venueLogoImage" (error)="onImageError($event)" loading="lazy" style="width: 100%; display: block;" [alt]="eventsDetailListByVenue?.venueName">
        </div>

        <div class="venue-left-image venue-desktop-only" [style.--left-bg-url]="getHeroBannerBg()">
          <img [src]="venueLogoImage" (error)="onImageError($event)" [class.no-image]="isNoImage(venueLogoImage)" loading="lazy" [alt]="eventsDetailListByVenue?.venueName || 'Venue Image'">
        </div>
        <ng-template #venueInfoDetails>
          <div class="web-adress" fxLayout="row" fxLayoutGap="20px">
            <div class="venue-web" fxLayout="row" fxLayoutGap="15px">
              <mat-icon>place</mat-icon>
              <div class="web-url" fxLayout="column">
                <span>{{'shared.labels.adress'|translate}}</span>
                <span class="address-text">{{adress+' '+townName+'/'+cityName}}</span>
              </div>
            </div>
          </div>

          <div class="venue-action-buttons">
            <a target="_blank" [href]="getAdressUrl()" class="venue-action-button">
              <mat-icon>directions</mat-icon>
              <span>Yol Tarifi Al</span>
            </a>
            <button *ngIf="parkingInfo" class="venue-action-button" (click)="openParkingModal()">
              <mat-icon>local_parking</mat-icon>
              <span>Otopark Bilgisi</span>
            </button>
          </div>

          <btx-venue-seat-plan [seatPlanImage]="seatPlanImage"></btx-venue-seat-plan>
        </ng-template>

        <div class="venue-desktop-only">
          <ng-container *ngTemplateOutlet="venueInfoDetails"></ng-container>
        </div>
      </aside>

      <div class="venue-content-right">
        <h1 class="venue-title venue-desktop-only">{{ venueName }}</h1>
        <!-- Etkinlik Bilgileri -->
        <div class="event-info-wrapper" fxLayout="column" fxLayoutGap="16px">
          <div fxLayout="column" class="venueList">
            <div class="event-list-head-holder">
              <h2 class="calendar-header" translate="performance.labels.eventCalendar"></h2>
              <div class="toggle-container">
                <button class="toggle-btn" [class.active]="calendarOrListStatus" (click)="calendarOrListStatus = true">
                  <mat-icon>calendar_today</mat-icon>
                  <span>{{ 'performance.links.calendar' | translate }}</span>
                </button>
                <button class="toggle-btn" [class.active]="!calendarOrListStatus"
                  (click)="calendarOrListStatus = false">
                  <mat-icon>list</mat-icon>
                  <span>{{ 'performance.links.list' | translate }}</span>
                </button>
              </div>
            </div>

            <ng-container *ngIf="!calendarOrListStatus">
              <ng-container *ngFor="let item of performanceItems">
                <btx-venue-list-item [listItem]="item"></btx-venue-list-item>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="calendarOrListStatus">
              <btx-calendar [data]="eventsDetailListByVenue?.performanceItems || []" [type]="'venue'"></btx-calendar>
            </ng-container>
          </div>

          <div class="venue-about">
            <h2 class="title heading-medium" translate="performance.labels.aboutVenue"></h2>
            <btx-read-more [text]="venueDescription" [maxLength]="1000">
            </btx-read-more>
          </div>

          <div class="venue-mobile-only">
            <ng-container *ngTemplateOutlet="venueInfoDetails"></ng-container>
          </div>

          <btx-venue-stay22 *ngIf="stay22Lat && stay22Long" [campaignID]="stay22CampaignId" [itemLat]="stay22Lat"
            [itemLong]="stay22Long" [itemVenue]="stay22Venue">
          </btx-venue-stay22>
        </div>

        <div class="side-image-container">
          <div class="side-image-wrapper">

            <div id='div-gpt-ad-1664353181968-0' style='min-width: 300px; min-height: 600px;'></div>
          </div>
        </div>
      </div>
    </div>
  </section>

</div>
